var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgPeople = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: 20,
    height: 20,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184 88c0 30.9-25.1 56-56 56-30.93 0-56-25.1-56-56 0-30.93 25.07-56 56-56 30.9 0 56 25.07 56 56zm24.4 108.3C178.7 222.7 160 261.2 160 304c0 34.3 11.1 65.8 32 90.5V416c0 17.7-14.3 32-32 32H96c-17.67 0-32-14.3-32-32v-26.8C26.16 371.2 0 332.7 0 288c0-61.9 50.14-112 112-112h32c23.1 0 46.2 7.5 64.4 20.3zM64 245.7c-9.96 11.2-16 26.1-16 42.3 0 16.2 6.04 31.1 16 42.3v-84.6zM448 416v-21.5c20-24.7 32-56.2 32-90.5 0-42.8-18.7-81.3-48.4-107.7C449.8 183.5 472 176 496 176h32c61.9 0 112 50.1 112 112 0 44.7-26.2 83.2-64 101.2V416c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32zm128-85.7c9.1-11.2 16-26.1 16-42.3 0-16.2-6.9-31.1-16-42.3v84.6zM568 88c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-30.93 25.1-56 56-56s56 25.07 56 56zm-312 8c0-35.35 28.7-64 64-64s64 28.65 64 64c0 35.3-28.7 64-64 64s-64-28.7-64-64zm192 208c0 44.7-26.2 83.2-64 101.2V448c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-42.8c-37.8-18-64-56.5-64-101.2 0-61.9 50.1-112 112-112h32c61.9 0 112 50.1 112 112zm-192 42.3v-84.6c-10 11.2-16 26.1-16 42.3 0 16.2 6 31.1 16 42.3zm128-84.6v84.6c9.1-11.3 16-26.1 16-42.3 0-16.2-6.9-31.1-16-42.3z"
  })));
};

export { SvgPeople as ReactComponent };